/**
 * Shared list of business industries — sourced from a single place so
 * BusinessPortalHome, NewBusinessPage, and any admin filter all agree.
 * "other" is a special value that unlocks a free-text "please specify"
 * field in the create form; it's stored as-is in `industry` on the
 * business doc.
 */
/**
 * The canonical list — includes legacy `charity` so any existing DB
 * documents still resolve to a human label. UI consumers should import
 * `UI_INDUSTRIES` instead (charity filtered out to avoid duplication
 * with the new `charities` plural).
 */
export const INDUSTRIES = [
  "restaurant", "hotel", "hospital", "school", "lawyer", "doctor",
  "realtor", "manufacturer", "distributor",
  "charity",       // legacy — kept for backwards compat
  "charities",     // new plural label — takes precedence in UI
  "organizations", // NGOs, associations, community groups
  "retail",
  "handyman", "it", "tourism", "education", "construction", "agriculture",
  "other",
];

/** UI-facing subset — no legacy duplicates. Prefer this everywhere. */
export const UI_INDUSTRIES = INDUSTRIES.filter((i) => i !== "charity");

/**
 * Dedupe & pretty-print helpers. The DB stores lowercase keys but the
 * UI shows Title Case for readability.
 */
export const INDUSTRY_LABELS = {
  it:            "IT",
  ngo:           "NGO",
  organizations: "Organizations",
  charities:     "Charities",
  other:         "Other",
};

export function labelFor(industry) {
  if (!industry) return "";
  const key = String(industry).toLowerCase();
  return INDUSTRY_LABELS[key] || key.replace(/\b\w/g, (c) => c.toUpperCase());
}
